import React, { useState } from "react";

import componentStyles from "./COIComponent.css";
import { QuestionFooter, QuestionHeader } from "./Question";


function COIComponent ({ completeFormModel, config, onChange, onDelete }) {
	const [ localConfig, setLocalConfig ] = useState(config);

	const onChangeConfig = newProps => {
		const newConfig = { ...localConfig, ...newProps };
		onChange(newConfig);
		setLocalConfig(newConfig);
	};

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig}></QuestionHeader>
			<div className={`ui form ${componentStyles.infoHeader}`}>
				<div className={componentStyles.infoHeaderColumn1}><strong>Name</strong></div>
				<div className={componentStyles.infoHeaderColumn2}><strong>Role</strong></div>
				<div className={componentStyles.infoHeaderColumn2}><strong>Disclosure</strong></div>
				<div className={componentStyles.infoHeaderColumn2}><strong>Status</strong></div>
				<div className={componentStyles.infoHeaderColumn2}><strong>Resolution</strong></div>
			</div>
			<div className={`ui form ${componentStyles.infoRow}`}>
				<div className={componentStyles.infoRowColumn}><i>No research team members have been added yet.</i></div>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</>
	);
}

COIComponent.showInPalette = () => true;

COIComponent.paletteInformation = () => ({
	id: "cayuseCOIComponent",
	name: "Outside Interests Disclosure Search",
	type: "cayuseCOIComponent",
	group: "sponsoredProject"
});

COIComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-coi-component",
		customStencilId: "null"
	},
	type: "cayuseCOIComponent",
	cayuseShortLabel: "Outside Interests Disclosure Search"
});


export default COIComponent;
